const editMtrTitle = 'Редактирование МТР';
const createMtrTitle = 'Создание МТР';
const editPriceTitle = 'Редактирование расценки';
const workOrderStructureTitle = 'Формирование структуры Наряд-Заказа';
const workOrderStructureEditTitle = 'Редактирование структуры Наряд-Заказа';
const priceMTRDistribution = 'Редактирование стоимости';
const editOtherPrice = 'Редактирование прочих затрат';
const workOrderChangeOtherDistribution = 'Распределение прочих затрат';
const actKc2OtherTitle = 'Реквизиты Акта КС-2';
const resetActKC2Calculated = 'Сбросить до рассчитанных значений';
const actsKC2GroupingTitle = 'Формирование Актов КС-2';
const changeStructureEditTitle = 'Редактирование структуры Изм.';
const applyMtr = 'Сопоставление с прейскурантом МТР';
const moveVolumesTitle = 'Перенос объемов между сезонами для расценки';
const getWorkOrderVersions = 'Получение версий наряд заказа';
const moveObjectVolumesTitle = 'Перенос объемов между сезонами для объекта';
const addUer = 'Добавление расценки из прейскуранта расценок';
const uerActsKc2AnalyticsTitle = 'диаграмма фактического освоения фо';
const updateRatioRowTitle = 'Редактирование нового коэффициента из ВОР';
const calculationTitle = 'Расчет НМЦ';
const setWorkVolumeFormulaValue = 'Ввод формулы ВОР';
const createOtherCostTitle = 'Создание прочих затрат';
const createLimitedCostTitle = 'Создание лимитированных затрат';
const updateLimitedCostTitle = 'Редактирование лимитированных затрат';

export const requestsTitlesMap = {
    addMtrRowToWorkOrderFromPriceList: createMtrTitle,
    uerUpdateMtrRow: editMtrTitle,
    updateWorkOrderChangeMtr: editMtrTitle,
    updateMtrToActKC2FromPriceList: editMtrTitle,
    updateWorkOrderChangeOther: editOtherPrice,
    updateWorkOrderChangeRatio: 'Редактирование коэффициента',
    updateRatioToActKC2FromPriceList: 'Редактирование коэффициента',
    updateWorkOrderChangeUer: editPriceTitle,
    updateUerToActKC2FromPriceList: editPriceTitle,
    updateOrderRequisites: 'Обновление реквизитов',
    workOrderPriceRowDetails: 'Состав сметы',
    bimWorkOrderSeasonSelectionList: workOrderStructureTitle,
    bimWorkOrderObjectSelectionList: workOrderStructureTitle,
    bimIncludeContractObjectToWorkOrder: workOrderStructureTitle,
    bimExcludeContractObjectFromWorkOrder: workOrderStructureTitle,
    bimIncludeWorkOrderSeason: workOrderStructureTitle,
    bimWorkOrderSeasonsUpdate: workOrderStructureTitle,
    bimCompleteStructureFormation: workOrderStructureTitle,
    bimIncludeAllObjectsToWorkOrder: workOrderStructureTitle,
    bimExcludeAllObjectsFromWorkOrder: workOrderStructureTitle,
    bimMoveWorkOrderObject: workOrderStructureTitle,
    bimCreateWorkOrderObject: 'Создание объекта',
    bimUpdateWorkOrderObject: 'Редактирование объекта',
    bimCreateWorkOrderSubObject: 'Создание подобъекта',
    bimUpdateWorkOrderSubObject: 'Редактирование подобъекта',
    bimWorkOrderDeleteObject: 'Удаление объекта',
    bimWorkOrderDeleteSubObject: 'Удаление подобъекта',
    bimWorkOrderPriceMTRDistribution: priceMTRDistribution,
    bimWorkOrderPriceMTRDistributionTotal: priceMTRDistribution,
    bimUpdateWorkOrderPriceMTRDistribution: priceMTRDistribution,
    bimMoveContractObject: 'Структура договора',
    addToBimWorkOrder: 'Добавление прочих',
    addOtherToBimWorkOrderChange: 'Добавление прочих',
    bimUpdateWorkOrderOther: editOtherPrice,
    bimUpdateWorkOrderOtherDistribution: workOrderChangeOtherDistribution,
    bimRemoveActsKC2: 'Удаление Акта КС-2',
    workOrderChangeDistributionData: workOrderChangeOtherDistribution,
    updateOtherCostDistribution: workOrderChangeOtherDistribution,
    uerCalcWorkOrderOtherDistribution: workOrderChangeOtherDistribution,
    updateWorkOrderChangeOtherDistribution: workOrderChangeOtherDistribution,
    bimActKC2Other: actKc2OtherTitle,
    bimUpdateActKC2Other: actKc2OtherTitle,
    bimIsUniqueActKC2OtherInternalNumber: actKc2OtherTitle,
    bimRemoveActKC2Other: 'Удаление прочих затрат',
    bimUpdateActKC2Totals: 'Перезаписать Акт КС-2',
    createOther: createOtherCostTitle,
    bimSetActKC2OtherCost: editOtherPrice,
    createCatalog: 'Создать справочник',
    bimWorkOrderObjectSelectionListIsIncluded: 'Редактирование структуры Наряд-Заказа',
    createBimFrameContractOrder: 'Создание Наряд-Заказа',
    createBimContractOrder: 'Создание Расчета по Договору',
    bimExportWorkOrderPrices: 'Выгрузка накопительной ведомости по Наряд-Заказу',
    bimReImportContractObjects: 'Загрузка нового файла',
    bimImportContractObjects: 'Загрузка структуры договора',
    bimDeleteContractObject: 'Создание объекта/подобъекта',
    createCatalogOtherCostVariable: 'Создание переменной',
    updateCatalogOtherCostVariable: 'Редактирование переменной',
    removeCatalogOtherCostVariable: 'Удаление переменной',
    updateActTotalLimited: 'Применение лимитированных затрат для Акта',
    resetActKC2AllCalculated: resetActKC2Calculated,
    resetActKC2ItemCalculated: resetActKC2Calculated,
    setActKC2InputValue: 'Корректировка рассчитанных значений',
    createCatalogOtherCostVariableGroup: 'Создание группы переменных',
    updateCatalogOtherCostVariableGroup: 'Редактирование группы переменных',
    removeCatalogOtherCostVariableGroup: 'Удаление группы переменных',
    projectsList: 'Загрузка реестра проектов',
    getProject: 'Загрузка проекта',
    catalogList: 'Загрузка реестра справочников',
    catalogOtherCostVariables: 'Загрузка Справочника переменных для прочих затрат',
    bimFrameContractResults: 'Накопительная ведомость',
    bimCalcWorkOrderOtherDistribution: workOrderChangeOtherDistribution,
    bimCalcWorkOrderChangeOtherDistribution: workOrderChangeOtherDistribution,
    bimUseActKC2TotalInflation: 'Итоги Акта КС-2',
    bimUseActKC2OtherTotalInflation: 'Итоги Акта',
    bimActsKc2GroupCreate: actsKC2GroupingTitle,
    bimActsKc2GroupUpdate: actsKC2GroupingTitle,
    uerActsKc2GroupCreate: actsKC2GroupingTitle,
    uerActsKc2GroupUpdate: actsKC2GroupingTitle,
    actsKc2GroupDelete: 'Удаление группы актов КС-2',
    bimWorkOrderChangeUpdateOther: editOtherPrice,
    uerWorkOrderObjectSelectionList: workOrderStructureEditTitle,
    uerIsUniqueContractObjectName: workOrderStructureEditTitle,
    uerCreateWorkOrderObject: workOrderStructureEditTitle,
    uerUpdateWorkOrderObject: workOrderStructureEditTitle,
    uerIsUniqueContractSubObjectName: workOrderStructureEditTitle,
    uerCreateWorkOrderSubObject: workOrderStructureEditTitle,
    uerUpdateWorkOrderSubObject: workOrderStructureEditTitle,
    bimUpdateWorkOrderChangeSubObject: changeStructureEditTitle,
    uerContractObjects: 'Структура договора',
    uerRemoveUnusedContractOtherCosts: 'Лимиты по прочим затратам',
    bimExportWorkOrderChangeAnalyticsAsExcel: 'Выгрузка аналитики изменения НЗ',
    bimExportWorkOrderChange: 'Выгрузка Изм. к НЗ',
    uerExportWorkOrderChangeAnalyticsAsExcel: 'Выгрузка аналитики изменения НЗ',
    bimWorkOrderVersions: getWorkOrderVersions,
    uerWorkOrderVersions: getWorkOrderVersions,
    bimGetExportWorkOrderVersions: getWorkOrderVersions,
    uerGetExportWorkOrderVersions: getWorkOrderVersions,
    workOrderChangeUerPriceList: addUer,
    uerExcludeContractObjectFromWorkOrder: workOrderStructureEditTitle,
    uerIncludeContractObjectToWorkOrder: workOrderStructureEditTitle,
    uerMtrRowsForComparison: applyMtr,
    applyMtr,
    uerExportWorkOrderPrices: 'Выгрузить накопительную ведомость',
    bimUseActKC2InflationValue: 'Инфляция',
    bimCreateContractSubObject: 'Создание подобъекта',
    bimUpdateContractSubObject: 'Редактирование подобъекта`',
    bimCreateContractObject: 'Создание объекта',
    bimUpdateContractObject: 'Редактирование объекта',
    uerExportContractResults: 'Выгрузить накопительную ведомость',
    rollbackWorkOrderChange: 'Смена версии наряд-заказа',
    uerCreateActKC2Correction: 'Создание корректировочного акта',
    uerUpdateActKC2Correction: 'Реквизиты корректировочного Акта КС-2',
    uerWorkOrderChangeUerRemainders: moveVolumesTitle,
    uerMoveWorkOrderChangeUerReminders: moveVolumesTitle,
    bimPriceAnalytics: 'аналитика изменения сметы',
    uerMoveWorkOrderChangeObjectReminders: moveObjectVolumesTitle,
    uerWorkOrderChangeObjectsForReminders: moveObjectVolumesTitle,
    bimExcludeContractObjectFromWorkOrderChange: changeStructureEditTitle,
    bimIncludeContractObjectToWorkOrderChange: changeStructureEditTitle,
    bimWorkOrderChangeSeasonsUpdate: changeStructureEditTitle,
    uerRemoveWorkOrderObject: workOrderStructureEditTitle,
    removeWorkOrderChangeObject: 'Удаление объекта / подобъекта',
    moveWorkOrderChangeObject: 'Перемещение объекта / подобъекта',
    createActKC3: 'Формирование справки КС-3',
    updateActKC3: 'Редактирование справки КС-3',
    currentEstimateBasis: 'Получение стоимости расценки по виду строительства',
    updateUerPriceListRow: editPriceTitle,
    updateUerToWorkOrderFromPriceList: editPriceTitle,
    createUerRow: 'Создание расценки',
    exportActKC3FromListAsExcel: 'Выгрузка Справки КС-3',
    parsedCreateUer: 'Создание расценки',
    exportWorkOrderChange: 'Выгрузка Изм к НЗ',
    uerIncludeContractObjectToWorkOrderChange: changeStructureEditTitle,
    uerExcludeContractObjectFromWorkOrderChange: changeStructureEditTitle,
    uerWorkOrderChangeObjectSelectionList: changeStructureEditTitle,
    uerWorkOrderChangeObjectSelectionListIsIncluded: changeStructureEditTitle,
    uerCreateWorkOrderChangeObject: changeStructureEditTitle,
    uerCreateWorkOrderChangeSubObject: changeStructureEditTitle,
    uerUpdateWorkOrderChangeObject: changeStructureEditTitle,
    uerUpdateWorkOrderChangeSubObject: changeStructureEditTitle,
    uerRemoveWorkOrderChangeObjectItem: changeStructureEditTitle,
    uerSetWorkOrderChangeLastSeason: changeStructureEditTitle,
    uerAddWorkOrderChangeFromXml: 'Добавление ведомости объемов работ',
    workOrderChangeObjects: 'Изм к НЗ',
    uerUpdateWorkOrderSeasons: workOrderStructureEditTitle,
    uerWorkOrderPriceListUer: addUer,
    addPricesToWorkOrder: addUer,
    addPricesToWorkOrderChange: addUer,
    uerPriceListRatioUerRows: 'Расценки к Коэффициенту',
    uerPriceListRatioRows: 'Прейскурант коэффициентов',
    uerContractChangePriceListRatioRows: 'Прейскурант коэффициентов ДС',
    deleteOtherFromWorkOrderChange: 'Удаление записи',
    deletePriceWorkOrderChange: 'Удаление записи',
    updateWorkOrderActOtherComment: 'редактирование комментария в Акте КС-2',
    updateWorkOrderActPriceComment: 'редактирование комментария в Акте КС-2',
    uerActsKC2AnalyticsByUer: uerActsKc2AnalyticsTitle,
    uerActsKC2AnalyticsBySeasons: uerActsKc2AnalyticsTitle,
    uerCreateContractSubObject: 'Создание подобъекта',
    uerUpdateContractSubObject: 'Редактирование подобъекта',
    uerWorkOrderObjectTotals: 'Итоги объекта и подобъектов строительства',
    createRatioRow: 'Создание коэффициента',
    updateRatioRow: updateRatioRowTitle,
    updateRatioToWorkOrderFromPriceList: updateRatioRowTitle,
    uerPriceListRatioRowsWithScopes: 'Добавление коэффициента из прейскуранта коэффициентов',
    uerApplyPriceListUerRatioRows: 'Добавление коэффициента из прейскуранта коэффициентов',
    uerSetActKC2Formula: 'Ввод формулы',
    saveOrUpdateWorkOrderChangeSeasonVolume: 'Добавление объемов',
    uerClosingWorkOrderChangeDefaults: 'Создание закрывающего Изм. к НЗ',
    uerCreateClosingWorkOrderChange: 'Данные закрывающего Изм. к нз',
    uerContractOtherCostLimitSpanSelectionList: 'Перераспределение лимитов по договору для вида строительства',
    uercCalculationDefaults: calculationTitle,
    uercCalculation: calculationTitle,
    uercCreateCalculation: calculationTitle,
    uercUpdateCalculation: calculationTitle,
    bimcCalculationDefaults: calculationTitle,
    bimcCalculation: calculationTitle,
    bimcCreateCalculation: calculationTitle,
    bimcUpdateCalculation: calculationTitle,
    updatePriceWorkScope: 'Редактирование состава работ',
    uerContractOtherCostForUpdate: editOtherPrice,
    bimContractOtherCost: editOtherPrice,
    uerUpdateContractOtherCostFromCatalog: editOtherPrice,
    uerUpdateContractOtherCost: editOtherPrice,
    bimUpdateContractOtherCost: editOtherPrice,
    uerUpdateOtherCostToActKC2: editOtherPrice,
    bimModifyContractOtherCost: editOtherPrice,
    uerUpdateContractOtherCostToWorkOrderFromPriceList: editOtherPrice,
    copyCollectionUerFromCatalog: 'Наполнение сборника',
    uercMoveCalculationObject: 'Структура расчета',
    updateCatalogUERBaseCostWorkScopes: 'Редактирование состава работ',
    uercParseUerBaseCostBasis: 'Загрузка сметы-основания',
    uercSetCollectionUERBaseCostRowProperties: 'массовое заполнение расценок',
    uercRemoveCollectionUERBaseCostRows: 'Удаление записей',
    uercRemoveAllCollectionUERBaseCostRows: 'Очистка сборника',
    uercUpdateCalculationOtherCost: 'Редактирование прочих затрат',
    bimcUpdateCalculationOtherCost: editOtherPrice,
    createOtherCostTemplate: 'Создание шаблона прочих затрат',
    otherCostTemplateDataForUpdate: 'Редактирование шаблона прочих затрат',
    uerCreateCalculationLimitedCost: createLimitedCostTitle,
    uerUpdateCalculationLimitedCost: updateLimitedCostTitle,
    bimcCreateCalculationLimitedCost: 'Создание лимитированных затрат',
    bimcUpdateCalculationLimitedCost: 'Редактирование лимитированных затрат',
    bimcCalculationLimitedCostForUpdate: 'Редактирование лимитированных затрат',
    createGlobalOtherCost: createOtherCostTitle,
    updateGlobalOtherCost: editOtherPrice,
    createGlobalLimitedCost: createLimitedCostTitle,
    updateGlobalLimitedCost: updateLimitedCostTitle,
    uercSetWorkVolumeFormulaValue: setWorkVolumeFormulaValue,
    bimCreateOther: createOtherCostTitle,
};
